import { useState, useEffect } from 'react'
import useCurrentReport from '../../../../hooks/useCurrentReport'
import useUpdateReportDoc from '../../../../hooks/useUpdateReportDoc'
import { StoolState } from '../utils/types'

const isStoolDataComplete = (stool: StoolState['stool']): boolean => {
  return !!(
    stool.type &&
    stool.color &&
    stool.odor &&
    stool.volume &&
    stool.float !== undefined &&
    stool.daily !== undefined &&
    stool.times &&
    stool.giSymptoms &&
    stool.giSymptoms.length > 0
  )
}

const isUrineDataComplete = (urine: StoolState['urine']): boolean => {
  return !!(urine.timesDaily && urine.color && urine.odor)
}

export default function useStoolState() {
  const currentReport = useCurrentReport()
  const updateReport = useUpdateReportDoc()
  const [state, setState] = useState<StoolState>({ stool: {}, urine: {} })

  useEffect(() => {
    if (currentReport?.stool) {
      setState(currentReport.stool)
    }
  }, [currentReport])

  const updateState = (newState: StoolState) => {
    // Automatically set complete flags based on data completeness
    const stoolComplete = isStoolDataComplete(newState.stool)
    const urineComplete = isUrineDataComplete(newState.urine)

    const updatedState: StoolState = {
      stool: {
        ...newState.stool,
        complete: stoolComplete,
      },
      urine: {
        ...newState.urine,
        complete: urineComplete,
      },
    }

    setState(updatedState)
    updateReport({
      stool: updatedState,
    })
  }

  return {
    state,
    setState: updateState,
  }
}
